export interface PaginationOptions {
  orderBy: string;
  limit: number;
  offset: number;
}

export interface PaginationParams {
  sort?: {
    active: string,
    direction: string
  };
  paginator: {
    pageSize: number;
    pageIndex: number
  } | any;
}

export function toPaginationOptions({ sort, paginator }: PaginationParams): PaginationOptions {
  return {
    orderBy: sort ? `${sort.active}_${sort.direction}` : undefined,
    limit: paginator.pageSize,
    offset: paginator.pageIndex * paginator.pageSize
  };
}
